module.exports = __webpack_public_path__ + "img/logo-mobile-light.41bfd4b9.svg";